import { CustomTab } from '../../../components/customTab';
import './index.scss';
import { useEffect, useState } from 'react';
import {
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../../utils/analytics';

import { useAppSelector } from '../../../storeHook';
import { MVPDataTableInternal } from './table';

import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';

import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { MVPFiltersProps } from '../constants';
import CommonAppBar from '../../../components/commonAppBar';

type TChartsTab = {
  value: string;
  label: string;
  tabIndex: string;
  fragment: string;
};

export const MVPReports: React.FC<MVPFiltersProps> = ({
  onNavigate,
}) => {
  const user = useSelector(
    (state: RootState) => state.authUser
  );
  const [requestedCount, setRequestedCount] = useState();
  const [receievedCount, setReceivedCount] = useState();
  const [searchParams] = useSearchParams();

  const CHART_LIST: TChartsTab[] = [
    {
      value: user?.role !== 'FA' ? 'requested' : 'requests',
      label: `${
        user?.role !== 'FA' ? 'Requested' : 'Requests'
      } (${requestedCount})`,
      tabIndex: '1',
      fragment:
        user?.role !== 'FA' ? 'requested' : 'requests',
    },
    {
      value: user?.role !== 'FA' ? 'received' : 'submitted',
      label: `${
        user?.role !== 'FA' ? 'Received' : 'Submitted'
      } (${receievedCount})`,
      tabIndex: '2',
      fragment:
        user?.role !== 'FA' ? 'received' : 'submitted',
    },
  ];

  const { hash, search, pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (performance?.navigation?.type === 1 && search) {
      navigate(`${pathname}${hash}`, { replace: true });
    }
  }, [search, navigate, pathname, hash]);
  const [activeTab, setActiveTab] = useState(
    CHART_LIST.find((ele) => `#${ele.fragment}` === hash) ||
      searchParams?.get('tab') == 'REQUESTED'
      ? CHART_LIST[0]
      : searchParams?.get('tab') == 'RECEIVED'
      ? CHART_LIST[1]
      : CHART_LIST[0]
  );

  const user_name = useAppSelector(
    (state) => state.authUser?.userName
  );

  useEffect(() => {
    const tabFromHash = CHART_LIST.find(
      (ele) => `#${ele.fragment}` === hash
    );
    if (tabFromHash && tabFromHash !== activeTab) {
      setActiveTab(tabFromHash);
    }
  }, [hash]);

  const handleChange = (newSelectedTab: TChartsTab) => {
    if (newSelectedTab) {
      appLogEvent(CUSTOM_EVENTS.TAB_CHANGE_TO_, {
        user_name,
        tab: newSelectedTab.label,
      });
      setActiveTab(newSelectedTab);
    }
  };

  const [isMobileOrTablet, setIsMobileOrTablet] = useState(
    window.innerWidth < 1024
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth < 1024);
    };

    window.addEventListener('resize', handleResize);
    return () =>
      window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      {!isMobileOrTablet && (
        <CommonAppBar
          section={
            <>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}>
                All Reports
              </Typography>

              <Box sx={{ flexGrow: 1 }} />

              {user?.role !== 'FA' && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <div
                    // to="/mvp/archieved"
                    style={{
                      textDecoration: 'none',
                      color: 'rgba(0, 105, 112, 1)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      cursor: 'pointer',
                    }}>
                    <ArchiveOutlinedIcon
                      style={{
                        color: 'rgba(0, 105, 112, 1)',
                      }}
                    />
                    <span
                      onClick={() =>
                        onNavigate?.('archievedReports')
                      }>
                      View Archived
                    </span>
                  </div>{' '}
                </div>
              )}
            </>
          }
        />
      )}
      <div style={{ marginTop: 50 }}></div>
      <CustomTab<TChartsTab, keyof TChartsTab>
        tabList={CHART_LIST}
        activeTab={activeTab}
        valueKey={'tabIndex'}
        labelKey={'label'}
        iconKey="icon"
        main={false}
        onTabChange={handleChange}
        showFilterButton={false}
        tabPanel={(tab) => {
          switch (tab?.tabIndex) {
            case '1':
              return (
                <MVPDataTableInternal
                  type={'REQUESTED'}
                  setRequestedCount={setRequestedCount}
                  setReceivedCount={setReceivedCount}
                  onNavigate={onNavigate}
                />
              );

            case '2':
              return (
                <MVPDataTableInternal
                  type={'RECEIVED'}
                  setRequestedCount={setRequestedCount}
                  setReceivedCount={setReceivedCount}
                  onNavigate={onNavigate}
                />
              );
          }
        }}
      />
    </div>
  );
};
